import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import CreateIcon from '@material-ui/icons/Create';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

class CheckboxAlertDialog extends React.Component {
  state = {
    open: false,
    options: this.props.options.map(option => ({ [option.value]: false }))
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleConfirm = () => {
    this.props.submit(this.state.options);
    this.setState({ open: false });
  }

  transition = (props) => {
    return <Slide direction="up" {...props} />;
  }

  handleChange = name => event => {
    const updated = this.state.options.map(option => {
      if (Object.keys(option)[0] === name) {
        return { [name]: event.target.checked }
      } else {
        return option
      }
    })
    this.setState({ options: updated })
  }

  renderCheckboxes = () => {
    return this.props.options.map((option, index) => {
      return (
        <FormControlLabel
          key={option.value}
          control={
            <Checkbox
              checked={this.state.options[index].value}
              onChange={this.handleChange(option.value)}
              value={option.value}
              color="primary"
            />
          }
          label={option.label}
        />
      )
    })
  }

  render() {
    return (
      <div className={this.props.className}>
        <Button variant={this.props.variant} disabled={this.props.disabled} color={this.props.color} onClick={this.handleClickOpen}>{this.props.buttonLabel}</Button>
        <Dialog
          fullWidth={true}
          open={this.state.open}
          TransitionComponent={this.transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            {this.props.title}
          </DialogTitle>
          <DialogContent>
            { this.renderCheckboxes() }
          </DialogContent>
          <DialogContent>
            <Typography variant='subheading' color='secondary' gutterBottom>
              { this.props.note }
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleConfirm} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default CheckboxAlertDialog;



// WEBPACK FOOTER //
// ./src/components/FormComponents/CheckboxAlertDialog/index.js